import { axiosInstance } from "../axios-instance";

const settings = "setting";
const logs = "logs";

const SettingsServices = {
  getSettings: () => axiosInstance.get(`${settings}`),

  updateSettings: (payload) =>
    axiosInstance.postForm(`${settings}/update`, payload),
  //////////////////////////////////////////////////////

  getLogs: () => axiosInstance.get(`${logs}`),
  getLog: (id) => axiosInstance.get(`${logs}/show/${id}`),
  getLogsByUser: (id, date) => axiosInstance.post(`${logs}/user/${id}`, date),
};

export default SettingsServices;
